// Small persistent prefs (localStorage, survives tab close unlike the
// sessionStorage tokens). Currently just the last-used email for "warm login":
// a returning visitor sees their email prefilled and can go straight to their
// passkey or password without retyping it.
const EMAIL_KEY = "life-os:email";

export const lastEmail = (): string => {
  try {
    return localStorage.getItem(EMAIL_KEY) || "";
  } catch {
    return ""; // private mode / storage disabled
  }
};

export const rememberEmail = (email: string): void => {
  try {
    localStorage.setItem(EMAIL_KEY, email);
  } catch {
    /* ignore - non-fatal */
  }
};

// Whether a passkey has been enrolled on this device, keyed by the account email
// so switching accounts resets it. Lets the UI show "already added" and block a
// duplicate enrolment. WebAuthn's excludeCredentials is the real backstop; this is
// the friendly UI signal (per-device, best-effort - cleared storage resets it).
const PK_KEY = "life-os:passkey";
const norm = (email: string): string => (email || "").trim().toLowerCase();

export const passkeyEnrolled = (email: string): boolean => {
  try {
    return !!norm(email) && localStorage.getItem(PK_KEY) === norm(email);
  } catch {
    return false;
  }
};

export const setPasskeyEnrolled = (email: string): void => {
  try {
    localStorage.setItem(PK_KEY, norm(email));
  } catch {
    /* ignore - non-fatal */
  }
};
